import React from 'react'

import { images } from '@zet/assets'
import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import Video from '@zet/common/components/videoBanner'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import {
  B2,
  B5,
  Icon,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import { APP_NAME } from '@zet/end-points'
import { useUserContext } from '@zet/feature-user'
import { useSpecificAppComms } from '@zet/feature-user/api/appComms/hooks'
import { i18n } from '@zet/localization'
import EmptyFolder from '@zet/svg/emptyFolder'
import { BUTTON_TYPE, DEVICE_HEIGHT, appVideos } from '@zet/utils/Constants'

import EmptyLeadButton from './emptyLeadButton'

export default function EmptyLeads({
  isFromBrand,
  withFilter = false,
  clearFilters,
}: {
  isFromBrand?: boolean
  withFilter?: boolean
  clearFilters?(): void
}) {
  const navigation = useNavigation()
  const { data: videoData } = useSpecificAppComms('appVideos')
  const { data: user } = useUserContext()

  return (
    <Stack
      style={{
        height: DEVICE_HEIGHT * 0.68,
        backgroundColor: '#fff',
      }}
      className="justify-around bg-white"
    >
      <>
        <Stack className=" items-center ">
          <Stack className=" mx-3 items-center">
            <EmptyFolder />
            <B5 className="text-grays-60 mt-3 ">
              {!withFilter
                ? i18n.t('myLeads.noLead')
                : i18n.t('myLeads.noLeadFilter')}
            </B5>
          </Stack>
          <Stack className="mt-4/2 mx-3">
            <EmptyLeadButton
              withFilter={withFilter}
              clearFilters={clearFilters}
              isFromBrand={isFromBrand}
            />
          </Stack>
        </Stack>

        {APP_NAME !== MY_TEAMS_ADVISOR ? (
          <Stack className="z-10 mx-3 mt-3 h-[168] overflow-hidden rounded-xl">
            <Video
              image={images.addCustomerThumbnail}
              icon={
                <Icon
                  type="VideoFilled"
                  size={53}
                  color={zetColors.error[100]}
                />
              }
              classname="absolute"
              videoId={appVideos.zetHowToEarn.videoId}
              videoData={videoData?.zetHowToEarn}
            />
          </Stack>
        ) : (
          <></>
        )}
      </>

      <Stack className="mx-3 pb-2">
        <PressableWithIntent
          type={BUTTON_TYPE.BUTTON}
          name="SellNow"
          onPress={() =>
            navigation.navigate('KnowYourCustomer', { source: 'emptyLeads' })
          }
          className="mb-2 w-full py-3"
          eventName="click_action"
          eventPayload={{
            item_name: isFromBrand
              ? 'brand_my_leads_start_selling'
              : 'my_leads_start_selling',
            used_id: user?.id,
          }}
        >
          <XStack className="items-center justify-center">
            <Icon type="RupeeCircleFilled" color="#fff" size={24} />
            <B2 style={{ color: 'white', marginLeft: 5 }}>
              {i18n.t('myLeads.sell')}
            </B2>
          </XStack>
        </PressableWithIntent>
      </Stack>
    </Stack>
  )
}
